import { Component } from 'react';
import { connect } from 'react-redux'
import React from 'react';
import { withRouter } from 'react-router';
// -- Application components
import App  from '../../components/Application';
import Login from '../../components/Login';
import Snackbar from 'material-ui/Snackbar';

import { unsetSnackbar } from '../../redux/actions/snackbarAction';
import { destroySession } from '../../redux/actions/globalActions';
import Loader from '../Helpers/Loader';
// -- Application styles
//import '../../assets/css/style.css';
import {isEditingInProgress} from '../../redux/actions/AppAction';
class Authenticator extends Component {
    constructor(props) {
        super(props);
        this.isEditingStillInProgress = this.isEditingStillInProgress.bind(this);
        this.state = {
            anchorOrigin: {}
        }
    }

    componentDidMount() {
        this.props.history.push(this.props.location.pathname);
        this.checkLoggedIn();
    }

    componentDidUpdate(prevProps, prevstate) {
        if (this.props.location.pathname !== prevProps.location.pathname || prevProps.user !== this.props.user) {
            this.checkLoggedIn();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.user.user_inactive_logout === true) {
            this.props.destroySession();
            setTimeout(function() { window.location.reload() }, 2000);
        }
    }

   checkLoggedIn() {
        const isLoggedIn = this.props.user.isLoggedIn;
        const readyForCode = this.props.user.ready_for_code;
        const isVerified = this.props.user.user_verified;

        if(!isVerified) {
            this.appComponent = <Login />
            if (!isLoggedIn && !readyForCode) {
                if(this.props.location.pathname !== '/wachtwoord-vergeten') {
                    //this.props.history.push('/login');

                    if(window.location.pathname !== '/login') {
						window.location.href ="/login";
					}
                    //
                }
            }else if(readyForCode){
                this.props.history.push('/login/verification');
            }
        }else{
            this.appComponent = <App />
            if(this.props.location.pathname === '/login') {
                this.props.history.push('/');
            }

             if(this.props.location.pathname === '/login/verification') {
                this.props.history.push('/');
            }

            if(this.props.user.user_profile.first_login === '1') {
                this.props.history.push('/');
            }
        }
    }

    isEditingStillInProgress() {
        let myObject = this.props.isEditingInProgress;
        let returnStatus = Object.keys(myObject).filter(function(key, index) {
            return myObject[key] === true
        });
        if(returnStatus.length === 0) {
            return false;
        }
        return true;
     }

    render() {
        return(
            <div className="holder">
               	{/*<Loader active={this.props.isEditingInProgress} />*/}               
                <div className="wrapper">
                    {this.appComponent ? this.appComponent : <Login />}
                    <div className="push"></div>
                </div>

               <Snackbar
                  style={{right: '15px', left: 'initial', transform: 'translate(0, 0)', bottom: 'auto', top: '15px'}}
                  open={this.props.snackbar.display_snackbar}
                  message={this.props.snackbar.snackbar_message}
                  autoHideDuration={4000}
                  onRequestClose={this.props.unsetSnackbar}

                />
            </div>
        )

    }
}

function mapStateToProps(state, ownProps) {

    return {
        user: state.UserReducer,
        snackbar: state.SnackbarReducer,
        isEditingInProgress: state.AppReducer.isEditingInProgress
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        unsetSnackbar: (data) => dispatch(unsetSnackbar(data)),
        destroySession : () => dispatch(destroySession()),
        editingInProgress : bool => dispatch(isEditingInProgress(bool))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authenticator))



// WEBPACK FOOTER //
// ./src/components/Authenticator/index.js